export interface IncentiveProgramSigningError {
  incentiveProgramName: string;
  companyId: string;
  companyName: string;
  errorCode: string;
}

export interface IncentiveProgramSigningErrorResponse {
  errors: IncentiveProgramSigningError[];
  hasErrors: boolean;
}

export const MISSING_PAYEE_CODE = 'MISSING_PAYEE_CODE';
